import type { SchemaViewerFieldExpressionLabelProps } from "./schema-viewer-field-expression-label.type";

import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { useSchemaViewerFieldExpressionLabel } from "./schema-viewer-field-expression-label.hook";
import "./schema-viewer-field-expression-label.style.less";

const { Title, Text } = Typography;

export const SchemaViewerFieldExpressionLabel = ({
  label,
  expressionSchema,
}: SchemaViewerFieldExpressionLabelProps) => {
  const { t } = useTranslation();
  const {
    isModalOpen,
    expressionWithLabels,
    expressionWithValues,
    showModal,
    handleClose,
  } = useSchemaViewerFieldExpressionLabel(expressionSchema);

  return (
    <Flex align="center">
      <span>{label}</span>
      <Button type="text" icon={<InfoCircleOutlined />} onClick={showModal} />
      <Modal
        title={t("form:expression.calculation_detail")}
        className="expression-description-modal"
        open={isModalOpen}
        onCancel={handleClose}
        footer={
          <Button type="primary" onClick={handleClose}>
            {t("global:close")}
          </Button>
        }
        classNames={{
          container: "expression-description-modal--container",
          header: "expression-description-modal--header",
          body: "expression-description-modal--body",
          footer: "expression-description-modal--footer",
          close: "expression-description-modal--close",
        }}
      >
        <Flex vertical justify="center" gap="small">
          {expressionSchema.description && (
            <>
              <Title level={3}>{t("global:description")}</Title>
              {expressionSchema.description}
            </>
          )}
          <Text>
            <strong>{expressionSchema.label}</strong>
            {` = ${expressionWithLabels}`}
          </Text>
          {expressionWithValues && (
            <Text>
              <strong>{expressionSchema.label}</strong>
              {` = ${expressionWithValues}`}
            </Text>
          )}
        </Flex>
      </Modal>
    </Flex>
  );
};
